import { Slot } from "@radix-ui/react-slot";
import { cn } from "@scott/ui/client";
import type { ImgHTMLAttributes } from "react";

interface visaProps extends ImgHTMLAttributes<HTMLImageElement> {
  asChild?: boolean;
}

const Visa = ({ className, asChild = false }: visaProps) => {
  const Comp = asChild ? Slot : "svg";
  return (
    <Comp
      className={cn(className)}
      fill="none"
      height="38"
      viewBox="0 0 640 195.9"
      width="79"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M217.8 192.2L248.4 3.1h48.8l-30.5 189.1h-48.9m226-184.5C434.1 3.9 419-.2 400-.2c-48.3 0-82.3 25.7-82.6 62.4-.3 27.2 24.3 42.4 42.8 51.4 19 9.3 25.4 15.2 25.3 23.5-.1 12.7-15.2 18.5-29.2 18.5-19.6 0-29.9-2.9-46-9.9l-6.3-3-6.8 42.3c11.4 5.3 32.5 9.8 54.4 10.1 51.3 0 84.7-25.4 85.1-64.6.2-21.6-12.8-37.9-41-51.4-17.1-8.8-27.5-14.6-27.4-23.5 0-7.9 8.8-16.3 28-16.3 16-.3 27.5 3.4 36.6 7.3l4.4 2.2 6.5-41.1m125.3-4.5h-37.7c-11.7 0-20.5 3.3-25.6 15.7l-72.5 173.3h51.3s8.4-23.3 10.3-28.4c5.6 0 55.4.1 62.6.1 1.5 6.6 5.9 28.3 5.9 28.3h45.3l-39.6-189m-60.2 121.9c4-10.9 19.5-52.9 19.5-52.9-.3.5 4-11 6.5-18l3.3 16.3s9.4 45.1 11.3 54.6h-40.6zM176.9 3.2l-47.8 129L124 106c-9-30.3-36.7-63-67.7-79.4L100 192h51.7L228.6 3.2h-51.7"
        fill="#005098"
      />
      <path
        d="M84.7 3.1H5.9L5.3 7c61.3 15.7 101.8 53.5 118.6 99l-17.1-87C103.9 7.1 95.3 3.5 84.7 3.1z"
        fill="#F7A600"
      />
      <path
        d="M624.5 169.7c6 0 10.8 4.8 10.8 10.8 0 5.9-4.7 10.8-10.8 10.8-6 0-10.8-4.8-10.8-10.8 0-6 4.7-10.8 10.8-10.8zm0 19.9c4.9 0 8.7-4.1 8.7-9.1 0-5.1-3.8-9.1-8.7-9.1-4.9 0-8.7 4.1-8.7 9.1-.1 5.1 3.8 9.1 8.7 9.1zm-4-14.6h4.8c1.1 0 3.5.3 3.5 3.1 0 .7-.2 1.8-1.8 2.5v.1c1.4.2 1.4 1.5 1.5 2.6.1 1.7 0 2 .4 2.6h-2.1c-.4-.4-.3-.7-.4-2.5 0-1-.1-2-2.4-2h-1.6v4.5h-2V175zm2 4.8h2.3c1.6 0 2-1 2-1.7 0-1.3-.9-1.6-2.2-1.6h-2.1v3.3z"
        fill="#005098"
      />
    </Comp>
  );
};

Visa.displayName = "Visa";

export { Visa };
